import { render, staticRenderFns } from "./Breaks.vue?vue&type=template&id=5277c026&scoped=true&"
import script from "./Breaks.vue?vue&type=script&lang=js&"
export * from "./Breaks.vue?vue&type=script&lang=js&"
import style0 from "./Breaks.vue?vue&type=style&index=0&id=5277c026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277c026",
  null
  
)

export default component.exports